export default "__VITE_ASSET__DFrFG$1s__"